export default "__VITE_PUBLIC_ASSET__b80cd892__"